module.exports = __webpack_public_path__ + "static/img/person-one.065d15a0.png";